// extracted by mini-css-extract-plugin
module.exports = {"inlineBlock":"StatementDescriptor_inlineBlock__Etfgu","validationTips":"StatementDescriptor_validationTips__3PClv"};